import type { ASTEntityValueType } from 'src/api/generated/touring/types';
import type { TicketSalesAstEntityValueType } from '../../types';

export const mapTicketSalesAstEntityValueType = (
  value: ASTEntityValueType
): TicketSalesAstEntityValueType => ({
  id: value.id,
  label: value.label,
});
